import script from "./reviewer-info.vue?vue&type=script&setup=true&lang=js"
export * from "./reviewer-info.vue?vue&type=script&setup=true&lang=js"

import "./reviewer-info.vue?vue&type=style&index=0&id=3870047a&scoped=true&lang=css"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3870047a"]])

export default __exports__